import { createContext, useContext, useState, useEffect } from "react";

const dict = {
  id: {
    appName: "KQZ Business Management System",
    tagline: "ERP & POS F&B untuk Cafe, Coffee Shop, dan Resto",
    nav_dashboard: "Dashboard", nav_recipes: "Resep & HPP", nav_products: "Produk",
    nav_ingredients: "Bahan Baku", nav_bases: "Base (Pre-Mix)", nav_inventory: "Stok Inventory", nav_purchasing: "Purchasing PO",
    nav_pos: "Kasir POS", nav_customers: "Pelanggan", nav_finance: "Keuangan & Kas",
    nav_reports: "Laporan", nav_settings: "Pengaturan",
    save: "Simpan", cancel: "Batal", add: "Tambah", edit: "Ubah", delete: "Hapus",
    search: "Cari...", actions: "Aksi", confirmDelete: "Yakin hapus data ini?",
    logout: "Keluar", loading: "Memuat...", total: "Total", date: "Tanggal", name: "Nama",
    login: "Masuk", register: "Daftar", email: "Email", password: "Password",
    loginGoogle: "Masuk dengan Google", noAccount: "Belum punya akun?", haveAccount: "Sudah punya akun?",
    welcome: "Selamat datang kembali",
    totalSales: "Total Penjualan", totalPurchase: "Total Pembelian", totalProfit: "Total Profit",
    stockValue: "Nilai Stok", expense: "Pengeluaran", cashBalance: "Saldo Kas",
    salesTrend: "Tren Penjualan & Profit (30 hari)", topProducts: "Produk Terlaris",
    expenseBreakdown: "Rincian Pengeluaran", lowStock: "Stok Menipis", transactions: "Transaksi",
    quickPos: "Buka Kasir",
    recipeCost: "Biaya Resep", hppServing: "HPP/Porsi", suggestedPrice: "Harga Jual Rekomendasi",
    yieldQty: "Yield Produksi", servingSize: "Serving Size", wastage: "Susut (%)",
    ingredients: "Bahan", qty: "Qty", unit: "Satuan", price: "Harga", cost: "Biaya",
    purchaseQty: "Jumlah Satuan", purchasePrice: "Harga Beli", pricePerUnit: "Harga/Satuan (Otomatis)",
    costPerUnit: "Biaya/Satuan",
    produce: "Produksi", batches: "Jumlah Batch",
    deliveryApp: "Aplikasi Delivery", appFee: "Biaya Aplikasi", overheadPct: "Biaya Overhead (%)", posKasir: "Kasir",
    resetData: "Reset Data", resetTransactions: "Hapus Data Transaksi", resetAll: "Hapus Semua Data",
    addIngredient: "Tambah Bahan", history: "Riwayat", compare: "Bandingkan", version: "Versi",
    stock: "Stok", stockIn: "Stok Masuk", stockOut: "Stok Keluar", adjustment: "Adjustment",
    opname: "Stock Opname", movements: "Riwayat Mutasi", minStock: "Stok Min",
    purchaseOrders: "Purchase Order", purchases: "Pembelian", supplier: "Supplier",
    receive: "Terima Barang", createPO: "Buat PO", status: "Status",
    cart: "Keranjang", checkout: "Bayar", discount: "Diskon", tax: "Pajak", service: "Service",
    paymentMethod: "Metode Bayar", paid: "Dibayar", change: "Kembalian", printReceipt: "Cetak Struk",
    cash: "Tunai", subtotal: "Subtotal", empty: "Kosong",
    customer: "Pelanggan", cashier: "Kasir", outlet: "Outlet", category: "Kategori",
    product: "Produk", startDate: "Dari", endDate: "Sampai", export: "Export",
    expenses: "Pengeluaran", cashflow: "Arus Kas", cashIn: "Kas Masuk", cashOut: "Kas Keluar", income: "Pemasukan",
    businessSettings: "Pengaturan Bisnis", targetFoodCost: "Target Food Cost (%)",
    marginProfit: "Margin Profit (%)", taxPct: "Pajak (%)", servicePct: "Service Charge (%)",
    rounding: "Pembulatan (Rp)", costMethod: "Metode HPP", businessName: "Nama Bisnis",
    receiptHeader: "Header Struk", receiptFooter: "Footer Struk",
    users: "Pengguna", outlets: "Outlet", categories: "Kategori", units: "Satuan", suppliers: "Supplier",
    role: "Role", active: "Aktif",
    r_sales: "Laporan Penjualan", r_purchases: "Laporan Pembelian", r_inventory: "Laporan Inventory",
    r_hpp: "Laporan HPP", r_pl: "Laba Rugi", r_recipe: "Biaya Resep",
    all: "Semua", apply: "Terapkan",
    confirmDeletePurchase: "Mutasi ini berasal dari Pembelian/PO. Menghapusnya akan menghapus SELURUH PO, Pembelian, dan semua mutasi bahan terkait. Lanjutkan?",
    forgotPassword: "Lupa Password?", resetPassword: "Reset Password", newPassword: "Password Baru",
    sendReset: "Kirim Link Reset", resetLinkReady: "Link reset Anda (berlaku 1 jam):",
    resetSent: "Jika email terdaftar, link reset akan dibuat.", resetSuccess: "Password berhasil direset. Silakan login.",
    backToLogin: "Kembali ke Login", menuAccess: "Hak Akses Menu",
    transfer: "Transfer Antar Outlet", fromOutlet: "Dari Outlet", toOutlet: "Ke Outlet",
    stockPerOutlet: "Stok per Outlet", perOutlet: "Per Outlet", allOutlets: "Semua Outlet",
    lowStockPerOutlet: "Stok Menipis per Outlet", transferHint: "perlu transfer dari Gudang Utama",
    transfers: "Transfer", inTransit: "Dalam Perjalanan", received: "Diterima", cancelled: "Dibatalkan",
    voidRefund: "Void/Refund", refunded: "Refunded",
  },
  en: {
    appName: "KQZ Business Management System",
    tagline: "F&B ERP & POS for Cafe, Coffee Shop, and Resto",
    nav_dashboard: "Dashboard", nav_recipes: "Recipe & Costing", nav_products: "Products",
    nav_ingredients: "Raw Ingredients", nav_bases: "Bases (Pre-Mix)", nav_inventory: "Inventory Stock", nav_purchasing: "Purchasing & PO",
    nav_pos: "POS Cashier", nav_customers: "Customers", nav_finance: "Finance & Cash",
    nav_reports: "Reports", nav_settings: "Settings",
    save: "Save", cancel: "Cancel", add: "Add", edit: "Edit", delete: "Delete",
    search: "Search...", actions: "Actions", confirmDelete: "Are you sure you want to delete?",
    logout: "Logout", loading: "Loading...", total: "Total", date: "Date", name: "Name",
    login: "Sign In", register: "Register", email: "Email", password: "Password",
    loginGoogle: "Sign in with Google", noAccount: "No account?", haveAccount: "Have an account?",
    welcome: "Welcome back",
    totalSales: "Total Sales", totalPurchase: "Total Purchase", totalProfit: "Total Profit",
    stockValue: "Stock Value", expense: "Expense", cashBalance: "Cash Balance",
    salesTrend: "Sales & Profit Trend (30 days)", topProducts: "Top Products",
    expenseBreakdown: "Expense Breakdown", lowStock: "Low Stock Alert", transactions: "Transactions",
    quickPos: "Open POS",
    recipeCost: "Recipe Cost", hppServing: "HPP/Serving", suggestedPrice: "Suggested Price",
    yieldQty: "Production Yield", servingSize: "Serving Size", wastage: "Wastage (%)",
    ingredients: "Ingredients", qty: "Qty", unit: "Unit", price: "Price", cost: "Cost",
    purchaseQty: "Unit Quantity", purchasePrice: "Purchase Price", pricePerUnit: "Price/Unit (Auto)",
    costPerUnit: "Cost/Unit",
    produce: "Produce", batches: "Batches",
    deliveryApp: "Delivery App", appFee: "App Fee", overheadPct: "Overhead Cost (%)", posKasir: "Cashier",
    resetData: "Reset Data", resetTransactions: "Clear Transaction Data", resetAll: "Delete All Data",
    addIngredient: "Add Ingredient", history: "History", compare: "Compare", version: "Version",
    stock: "Stock", stockIn: "Stock In", stockOut: "Stock Out", adjustment: "Adjustment",
    opname: "Stock Opname", movements: "Stock Ledger", minStock: "Min Stock",
    purchaseOrders: "Purchase Orders", purchases: "Purchases", supplier: "Supplier",
    receive: "Receive", createPO: "Create PO", status: "Status",
    cart: "Cart", checkout: "Checkout", discount: "Discount", tax: "Tax", service: "Service",
    paymentMethod: "Payment Method", paid: "Paid", change: "Change", printReceipt: "Print Receipt",
    cash: "Cash", subtotal: "Subtotal", empty: "Empty",
    customer: "Customer", cashier: "Cashier", outlet: "Outlet", category: "Category",
    product: "Product", startDate: "From", endDate: "To", export: "Export",
    expenses: "Expenses", cashflow: "Cashflow", cashIn: "Cash In", cashOut: "Cash Out", income: "Income",
    businessSettings: "Business Settings", targetFoodCost: "Target Food Cost (%)",
    marginProfit: "Profit Margin (%)", taxPct: "Tax (%)", servicePct: "Service Charge (%)",
    rounding: "Rounding (Rp)", costMethod: "Costing Method", businessName: "Business Name",
    receiptHeader: "Receipt Header", receiptFooter: "Receipt Footer",
    users: "Users", outlets: "Outlets", categories: "Categories", units: "Units", suppliers: "Suppliers",
    role: "Role", active: "Active",
    r_sales: "Sales Report", r_purchases: "Purchase Report", r_inventory: "Inventory Report",
    r_hpp: "HPP Report", r_pl: "Profit & Loss", r_recipe: "Recipe Cost",
    all: "All", apply: "Apply",
    confirmDeletePurchase: "This movement comes from a Purchase/PO. Deleting it will remove the ENTIRE PO, Purchase, and all related item movements. Continue?",
    forgotPassword: "Forgot Password?", resetPassword: "Reset Password", newPassword: "New Password",
    sendReset: "Send Reset Link", resetLinkReady: "Your reset link (valid 1 hour):",
    resetSent: "If the email is registered, a reset link will be created.", resetSuccess: "Password reset successful. Please sign in.",
    backToLogin: "Back to Sign In", menuAccess: "Menu Access",
    transfer: "Inter-outlet Transfer", fromOutlet: "From Outlet", toOutlet: "To Outlet",
    stockPerOutlet: "Stock per Outlet", perOutlet: "Per Outlet", allOutlets: "All Outlets",
    lowStockPerOutlet: "Low Stock per Outlet", transferHint: "needs transfer from Main Warehouse",
    transfers: "Transfers", inTransit: "In Transit", received: "Received", cancelled: "Cancelled",
    voidRefund: "Void/Refund", refunded: "Refunded",
  },
};

const LangContext = createContext({ lang: "id", setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("kqz_lang") || "id");
  useEffect(() => { localStorage.setItem("kqz_lang", lang); }, [lang]);
  const t = (key) => dict[lang][key] || dict.en[key] || key;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}
